import api from './client'

export async function fetchCompanyOptions(params = {}) {
  const { data } = await api.get('/options/companies', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function fetchProjectOptions(params = {}) {
  const { data } = await api.get('/options/projects', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function fetchUserOptions(params = {}) {
  const { data } = await api.get('/options/users', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function fetchTeamOptions(params = {}) {
  const { data } = await api.get('/teams/', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function fetchBranchOptions(params = {}) {
  const { data } = await api.get('/options/branches', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function fetchDepartmentOptions(params = {}) {
  const { data } = await api.get('/options/departments', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function fetchTeamByProject(projectId) {
  const { data } = await api.get(`/teams/by-project/${projectId}`)
  return data
}

export async function fetchRoleOptions(params = {}) {
  const { data } = await api.get('/options/roles', { params })
  return Array.isArray(data) ? data : data?.items || []
}
